import { useTranslation } from 'react-i18next'

import { Alert, Button, ButtonWithSpinner, Modal, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const SwitchExchangeToRefundModal = ({ show, onClose, onConfirm, loading }) => {
  const { t } = useTranslation()

  return (
    <Modal show={show} onClose={onClose} title={t('Convertir cambio en devolución')} size="l">
      <Styles.Container>
        <Text type="bodyMRegular">
          {t(
            'Esta acción convertirá la solicitud de cambio de productos en una solicitud de devolución. Se cambiará el tipo de transacción, se eliminarán los nuevos productos solicitados por el cliente y se actualizará el resultado de la transacción como corresponda.'
          )}
        </Text>
        <Alert type="warning">{t('Esta acción no se podrá deshacer más adelante. ¿Quieres continuar?')}</Alert>
        <Styles.ActionsContainer>
          <Button onClick={onClose} variant="outlined" fullWidth>
            {t('Cancelar')}
          </Button>
          <ButtonWithSpinner
            fullWidth
            onClick={onConfirm}
            defaultLabel={t('Aceptar')}
            loadingLabel={t('Convirtiendo')}
            loading={loading}
            disabled={loading}
          />
        </Styles.ActionsContainer>
      </Styles.Container>
    </Modal>
  )
}

export default SwitchExchangeToRefundModal
